import $ from 'jquery';
window.$ = $;
window.jQuery = $;
import 'jquery.easing';

import * as CookieConsent from 'vanilla-cookieconsent';
window.CookieConsent = CookieConsent;
